import { useQuery } from '@tanstack/react-query';
import { authService } from '../lib/api/apiService';

/**
 * Hook pour récupérer l'utilisateur actuellement authentifié.
 * S'appuie sur React Query pour mutualiser l'appel à l'API.
 *
 * Comportement réactif :
 *  - Refetch automatique toutes les 60 s (polling).
 *  - Refetch quand l'utilisateur revient sur l'onglet.
 *  - Refetch au retour du réseau.
 *  - Les données sont considérées stale immédiatement → un changement
 *    de route provoque un refetch si la query est montée.
 *
 * Résultat : lorsque les permissions de l'utilisateur sont modifiées
 * côté back-office, la sidebar et les gardes de route se mettent à jour
 * sans que l'utilisateur ait besoin de recharger la page.
 */
const useCurrentUser = (options = {}) => {
  const isAuthenticated = authService.isAuthenticated();

  return useQuery({
    queryKey: ['current-user'],
    queryFn: () => authService.getCurrentUser({ forceRefresh: options.forceRefresh ?? true }),
    enabled: isAuthenticated,
    // Polling régulier pour capter les changements de rôle/permissions
    refetchInterval: options.refetchInterval ?? 60 * 1000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    staleTime: 0,
  });
};

export default useCurrentUser;

